module.exports = __webpack_public_path__ + "img/8.49820568.jpg";